export default __webpack_public_path__ + "static/wave180-04-76370c445189472848671d7f9b7431db.svg";